import React, { Component } from 'react'
import { Form, FormGroup, FormControl } from 'react-bootstrap'
import Button from '../Buttons'
import { Link } from 'react-router';
import { translate } from "react-translate"

@translate("NewsletterWidget")
export default class NewsletterWidget extends Component {

	constructor(props) {
		super(props);
		this.state = {
			email: this.props.error? this.proprs.email: "",
			error: this.props.error,
			error_message: this.props.error_message,
			sending: this.props.sending,
			sended: false,
			validation: {
				email: ''
			}
		}
	}

	onComponentWillMount(){
		this.props.clearNewsletterState();
	}

	handleChangeEmail(e) {

		this.setState({email: e.target.value}, () => {
			this.validateEmail(this.state.email);
		})

	}

	validateEmail(val) {
		var validation = this.state.validation;
		var error = true;

		var email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if(val == '' || !val.match(email) ) {
			validation['email'] = "error";
			error = false;
		} else {
			validation['email'] = "success"
		}
		this.setState({validation: validation});

		return error;
	}


	pressSuscribeNewslleter(e) {
		e.preventDefault();
		if(this.validateEmail(this.state.email)){
			this.props.onSuscribeNewslleter(this.state.email)
		}
	}

  render () {
		const { onSuscribeNewslleter, t } = this.props;
		if(this.state.sending){
			return (
				<div className="newsletter-form">
					<div className="newsletter-title"> {t("Enviando")} </div>
				</div>
			)
		}

		if(this.state.error) {
			return (
				<div className="newsletter-form">
					<div className="newsletter-title"> {t("Mensaje_Error")} </div>
				</div>
			)
		}
    return (
    	<div className="newsletter-form">
  		 	<div className="newsletter-title"> {t("Texto_Principal")} </div>
        <Form inline onSubmit={ (e) => { this.pressSuscribeNewslleter(e) } }>
          <FormGroup controlId="formNewsletter" validationState={this.state.validation.email}>
            <FormControl type="text" placeholder={t("Email")} value={this.state.email} onChange={(e) => {this.handleChangeEmail(e)}} />
          </FormGroup>
          <Button type={"submit"} text={t("Suscribirme")} classes="btn-primary btn-news" />
        </Form>
        <Link to="/newsletters" className="link-newsletter hidden-xs">{t("Consultar_Texto")}</Link>
    	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NewsletterWidget/index.js